import React, { createContext, useContext, useEffect, useState } from 'react';

const WishlistContext = createContext(null);

export function WishlistProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem('pra_wishlist') || '[]'); } catch { return []; }
  });

  useEffect(() => { localStorage.setItem('pra_wishlist', JSON.stringify(items)); }, [items]);

  const has    = (id) => items.some(i => i.id === id);
  const add    = (p)  => setItems(prev => prev.some(i => i.id === p.id) ? prev : [...prev, p]);
  const remove = (id) => setItems(prev => prev.filter(i => i.id !== id));
  const toggle = (p)  => setItems(prev => prev.some(i => i.id === p.id) ? prev.filter(i => i.id !== p.id) : [...prev, p]);
  const clear  = ()   => setItems([]);

  return (
    <WishlistContext.Provider value={{ items, has, add, remove, toggle, clear, count: items.length }}>
      {children}
    </WishlistContext.Provider>
  );
}

export function useWishlist() {
  const ctx = useContext(WishlistContext);
  if (!ctx) throw new Error('useWishlist must be used inside <WishlistProvider>');
  return ctx;
}
